import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import GeyserProLanding from "./pages/GeyserProLanding";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminLeads from "./pages/admin/AdminLeads";
import AdminLeadDetail from "./pages/admin/AdminLeadDetail";
import AdminDealers from "./pages/admin/AdminDealers";
import CookieConsent from "./components/CookieConsent";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/admin6y5dv2x/login" replace />;
  }
  return children;
};

// Language-aware Lead Form wrapper (Italian only)
const LeadFormWithLanguage = () => {
  return (
    <LanguageProvider>
      <GeyserProLanding />
    </LanguageProvider>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter basename={process.env.NODE_ENV === 'production' ? '/calcola-preventivo' : ''}>
          <Routes>
            {/* Main route - Italian only */}
            <Route path="/" element={<LeadFormWithLanguage />} />
            <Route path="/it" element={<LeadFormWithLanguage />} />
            
            {/* Admin Routes (obfuscated path) */}
            <Route path="/admin6y5dv2x/login" element={<AdminLogin />} />
            <Route path="/admin6y5dv2x/dashboard" element={
              <ProtectedRoute><AdminDashboard /></ProtectedRoute>
            } />
            <Route path="/admin6y5dv2x/leads" element={
              <ProtectedRoute><AdminLeads /></ProtectedRoute>
            } />
            <Route path="/admin6y5dv2x/leads/:leadId" element={
              <ProtectedRoute><AdminLeadDetail /></ProtectedRoute>
            } />
            <Route path="/admin6y5dv2x/dealers" element={
              <ProtectedRoute><AdminDealers /></ProtectedRoute>
            } />
            <Route path="/admin6y5dv2x" element={<Navigate to="/admin6y5dv2x/dashboard" replace />} />
            {/* Legacy /admin redirects to the obfuscated path */}
            <Route path="/admin/*" element={<Navigate to="/admin6y5dv2x/dashboard" replace />} />
            
            {/* Redirect old language routes to main */}
            <Route path="/de" element={<Navigate to="/" replace />} />
            <Route path="/en" element={<Navigate to="/" replace />} />
            <Route path="/es" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <CookieConsent />
      </AuthProvider>
    </div>
  );
}

export default App;
